const state = {
    general: undefined
}

export default state